// ====== services/categoryService.js ======
import apiCall, { endpoints } from './api';

/**
 * Service pour la gestion des catégories
 */
const categoryService = {
  /**
   * Récupérer toutes les catégories de la boutique
   */
  getCategories: async () => {
    try {
      console.log('🏷️ Récupération des catégories...');
      
      const response = await apiCall.get(endpoints.manager.categories.list);
      
      if (response.success) {
        console.log('✅ Catégories récupérées:', response.data?.length || 0);
        return response;
      } else {
        console.error('❌ Erreur récupération catégories:', response.message);
        return response;
      }
    } catch (error) {
      console.error('❌ Erreur lors de la récupération des catégories:', error);
      return {
        success: false,
        message: 'Erreur lors de la récupération des catégories'
      };
    }
  },

  /**
   * Créer une nouvelle catégorie
   */
  createCategory: async (categoryData) => {
    try {
      console.log('🏷️ Création de catégorie:', categoryData);
      
      const response = await apiCall.post(endpoints.manager.categories.create, categoryData);
      
      if (response.success) {
        console.log('✅ Catégorie créée:', response.data);
        return response;
      } else {
        console.error('❌ Erreur création catégorie:', response.message);
        return response;
      }
    } catch (error) {
      console.error('❌ Erreur lors de la création de la catégorie:', error);
      return {
        success: false,
        message: 'Erreur lors de la création de la catégorie'
      };
    }
  },

  /**
   * Mettre à jour une catégorie
   */
  updateCategory: async (categoryId, categoryData) => {
    try {
      console.log('🏷️ Mise à jour catégorie:', categoryId, categoryData);
      
      const response = await apiCall.put(endpoints.manager.categories.update(categoryId), categoryData);
      
      if (response.success) {
        console.log('✅ Catégorie mise à jour:', response.data);
        return response;
      } else {
        console.error('❌ Erreur mise à jour catégorie:', response.message);
        return response;
      }
    } catch (error) {
      console.error('❌ Erreur lors de la mise à jour de la catégorie:', error);
      return {
        success: false,
        message: 'Erreur lors de la mise à jour de la catégorie'
      };
    }
  },

  /**
   * Supprimer une catégorie
   */
  deleteCategory: async (categoryId) => {
    try {
      console.log('🏷️ Suppression catégorie:', categoryId);
      
      const response = await apiCall.delete(endpoints.manager.categories.delete(categoryId));
      
      if (response.success) {
        console.log('✅ Catégorie supprimée');
        return response;
      } else {
        console.error('❌ Erreur suppression catégorie:', response.message);
        return response;
      }
    } catch (error) {
      console.error('❌ Erreur lors de la suppression de la catégorie:', error);
      return {
        success: false,
        message: 'Erreur lors de la suppression de la catégorie'
      };
    }
  },

  /**
   * Récupérer une catégorie par ID
   */
  getCategoryById: async (categoryId) => {
    try {
      console.log('🏷️ Récupération catégorie:', categoryId);
      
      const response = await apiCall.get(endpoints.manager.categories.getById(categoryId));
      
      if (response.success) {
        console.log('✅ Catégorie récupérée:', response.data);
        return response;
      } else {
        console.error('❌ Erreur récupération catégorie:', response.message);
        return response;
      }
    } catch (error) {
      console.error('❌ Erreur lors de la récupération de la catégorie:', error);
      return {
        success: false,
        message: 'Erreur lors de la récupération de la catégorie'
      };
    }
  }
};

export default categoryService;